import {Component, inject, DestroyRef} from '@angular/core';
import {ItrentDebugService} from '../../../services/http/admin/itrent-debug.service';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {SHARED_IMPORTS} from "../../../shared/standalone-imports";

@Component({
  selector: 'app-debug-itrent-position',
  templateUrl: './debug-itrent-position.component.html',
  styleUrls: ['./debug-itrent-position.component.less'],
  imports: [SHARED_IMPORTS]
})
export class DebugItrentPositionComponent {
  private itrentDebugService = inject(ItrentDebugService);
  private destroyRef = inject(DestroyRef);
  private destroy$ = new Subject<void>();

  constructor() {
    this.destroyRef.onDestroy(() => {
      this.destroy$.next();
      this.destroy$.complete();
    });
  }


  positionId: string;
  rawPositionResponse: string;

  getRawResponseForPosition() {
    this.itrentDebugService.getRawResponseForPosition(this.positionId)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: response => this.rawPositionResponse = response
            });
  }
}
